import { type Genre, type Maybe } from '@tmdb-graphql-api/schema/types';

const sortComparator = (a: Maybe<Genre>, b: Maybe<Genre>) => {
  if (a && b && a.name > b.name) {
    return 1;
  }

  if (a && b && a.name < b.name) {
    return -1;
  }

  return 0;
};

export const formatGenres = (genres: Maybe<Genre>[] = []) =>
  genres.sort(sortComparator).reduce((acc: string, genre) => {
    if (!genre) {
      return acc;
    }

    return acc ? `${acc}/${genre.name}` : genre.name;
  }, '');
